// import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import "react-phone-input-2/lib/style.css";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import "./App.scss";
// import AppRoutes from './AppRoutes'
import Routes from "./Routes";
import LocalStorageManage from "./config/LocalStorageManage";
import OnKeyPressEvent from "./config/OnKeyPressEvent";
import { BrowserRouter } from "react-router-dom";
import AuthenticationService from "./component/services/AuthenticationService";
import { setProviderFlags } from "./utils/marketingTracking";
// import Css from "./Css";
// import MetaSEO from './MetaSEO';
global.successStatus = [200, 201, 202];
global.host = window.location.host;
global.userPermissions = new OnKeyPressEvent();
global.OnKeyPressEvent = new OnKeyPressEvent();
global.closee = (
  <img
    alt="close"
    title="Close Icon"
    className="pointer"
    src={global.OnKeyPressEvent.getS3ImageUrl("close-wel.svg")}
  />
);
global.LocalStorageManage = new LocalStorageManage();
global.url = window.location.origin;
global.oh = process.env.REACT_APP_BRAND_URL.includes(global.host)
  ? false
  : true;
global.theme = "kini"; //global.oh ? "oh" : "kini";
global.propertyName = process.env.REACT_APP_BRAND_URL.includes(global.host)
  ? "Kini Beach Haus"
  : process.env.REACT_APP_PROPERTY_URL.includes(global.host)
    ? "Kini Beach Haus / Las Olas"
    : " OHAI";
global.level = process.env.REACT_APP_BRAND_URL.includes(global.host)
  ? 2
  : process.env.REACT_APP_CORPORATE_URL.includes(global.host)
    ? 1
    : 3;
global.brandSlug = process.env.REACT_APP_BRAND_URL.includes(global.host)
  ? global.OnKeyPressEvent.getBrandSlug()
  : "";
global.property_slug = process.env.REACT_APP_PROPERTY_URL.includes(global.host)
  ? global.OnKeyPressEvent.getPropertySlug()
  : "";
global.country = "us";
//  global.themeUrl = "/" + global.theme + "/" + global.theme + "/";
// global.themeUrl = "/" + global.theme + "/";
global.themeUrl = "/";
global.countdown_time = parseFloat(2.5);
global.redirect_time = 5000;
global.dateFormat = "MM/DD/YY";
global.dateTimeFormat = "MM/DD/YY | hh:mm A";
global.hostName = window.location.hostname;
global.isMobile = window.innerWidth <= 767;
// global.keywords = "Airbnb Friendly Apartment Buildings,Homesharing,Short Term Rental";
global.description =
  "Homesharing-friendly apartments. Earn money when you're away. Flexible, furnished, and unfurnished apartments. ";
global.unsubscribeReasonList = [
  {
    label: "I no longer want to receive these emails",
    value: "I no longer want to receive these emails",
  },
  {
    label: "I never signed up for this mailing list",
    value: "I never signed up for this mailing list",
  },
  {
    label: "The emails are inappropriate",
    value: "The emails are inappropriate",
  },
  {
    label: "The emails are spam and should be reported",
    value: "The emails are spam and should be reported",
  },
  { label: "Other (fill in reason below)", value: "Other" },
];

function App() {
  useEffect(() => {
    const pixelId = process.env.REACT_APP_META_PIXEL_ID;
    if (!pixelId || typeof window === "undefined") {
      return;
    }

    const ensureMetaPixel = () => {
      if (typeof window.fbq === "function") {
        return;
      }

      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      window.fbq("init", pixelId);
      window.fbq("track", "PageView");
    };

    const timerId = window.setTimeout(ensureMetaPixel, 1500);
    return () => window.clearTimeout(timerId);
  }, []);

  useEffect(() => {
    AuthenticationService.getSettingData().then((res) => {
      if (res && res.status === 200 && res.data) {
        setProviderFlags({
          ADS_META_ENABLED: res.data.ADS_META_ENABLED,
          ADS_GOOGLE_ENABLED: res.data.ADS_GOOGLE_ENABLED,
          SIMPLIFI_ENABLED: res.data.SIMPLIFI_ENABLED,
        });
      }
    });
  }, []);

  useEffect(() => {
    let isActive = true;
    const APP_VERSION_KEY = "app_version";
    const VERSION_URL = "/version.json";

    const checkAppVersion = async () => {
      try {
        const cacheBuster = Date.now();
        const response = await fetch(`${VERSION_URL}?t=${cacheBuster}`, {
          cache: "no-store",
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        const remoteVersion =
          typeof data?.version === "string" ? data.version : null;
        if (!remoteVersion) {
          return;
        }

        const localVersion = localStorage.getItem(APP_VERSION_KEY);
        if (localVersion !== remoteVersion) {
          localStorage.setItem(APP_VERSION_KEY, remoteVersion);
          setTimeout(() => {
            if (isActive) {
              window.location.reload();
            }
          }, 500);
        }
      } catch (error) {
        // Keep the app usable even if the version check fails.
        console.warn("App version check failed.", error);
      }
    };

    checkAppVersion();

    return () => {
      isActive = false;
    };
  }, []);
  return (
    <>
      <HelmetProvider>
        <div className="App">
          {/* <Css /> */}
          {/* <MetaSEO /> */}
          <BrowserRouter basename="">
            {/* <AppRoutes /> */}
            <Routes />
          </BrowserRouter>
        </div>
      </HelmetProvider>
    </>
  );
}

export default App;
